import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

/**
 * Drives the app-level top banner (rendered by AppComponent) from feature pages.
 * StatusComponent sets the analysis message when the redesigned card is shown and
 * clears it on destroy. The default value is null, so screens that never set a
 * message show no banner.
 */
@Injectable({providedIn: 'root'})
export class StatusBannerService {
  private readonly message = new BehaviorSubject<string | null>(null);
  readonly message$: Observable<string | null> = this.message.asObservable();

  private readonly hideTitle = new BehaviorSubject<boolean>(false);
  readonly hideChromeTitle$: Observable<boolean> = this.hideTitle.asObservable();

  show(message: string): void {
    this.message.next(message);
  }

  clear(): void {
    this.message.next(null);
  }

  setHideChromeTitle(hidden: boolean): void {
    this.hideTitle.next(hidden);
  }
}
